/**
 * These are the absolute minimum clips required for a face collage to be enabled.
 * It's possible that a variant might display differently based on the number of
 * clips provided, but if there are fewer than this number, the face collage won't
 * be displayed at all.
 */
export const faceCollageVariantMinimumClipCount = {
    "top-bottom-static": 2,
    "bottom-static": 2,
    bubble: 2,
    warp: 2,
    carousel: 2,
    "stripes-right-skewed": 2,
    "top-bottom-carousel": 2,
    "grid-bounce": 2,
    "hex-grid": 2,
    "school-spirit": 2,
};
export function getIsFaceCollageEnabledForScene(faceCollageConfig, renderConfig) {
    if (!renderConfig.faceCollageEnabled) {
        return false;
    }
    if (!faceCollageConfig) {
        return false;
    }
    const minClipCount = faceCollageVariantMinimumClipCount[faceCollageConfig.variant];
    // The preview is shown before face detection is run. As a proxy
    // for showing actual faces, we use placeholders for each of the clips.
    // So for preview, we assume that any video clip may have faces.
    // After face detection, when faces is defined, we can count the actual
    // number of faces and decide whether to show the face collage.
    const clipsThatMayHaveFaces = renderConfig.clips.filter((clip) => clip.type === "video" &&
        (clip.faces === undefined || clip.faces?.length > 0));
    if (clipsThatMayHaveFaces.length < minClipCount) {
        return false;
    }
    return true;
}
